import { createElement } from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

var makeClassName = function makeClassName(strings, expressions, props) {
  var newStrings = [strings[0]];

  for (var index = 1; index < strings.length; index++) {
    var expression = expressions[index - 1];

    if (typeof expression === 'function') {
      newStrings.push(String(expression(props)));
    } else {
      newStrings.push(String(expression));
    }

    newStrings.push(strings[index]);
  }

  var className = newStrings.join(''); // TODO: validate class names

  return className;
};

var classNamed = function classNamed(ClassnamedComponent) {
  return function (strings) {
    var expressions = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      expressions[_i - 1] = arguments[_i];
    }

    return function (_a) {
      var className = _a.className,
          AsComponent = _a.as,
          props = __rest(_a, ["className", "as"]);

      var Component = AsComponent || ClassnamedComponent;
      return createElement(Component, _assign({
        className: (makeClassName(strings, expressions, props) + " " + (className || '')).replace(/\s+/g, ' ').trim()
      }, props));
    };
  };
};

var classnamed = classNamed;
export default classNamed;
export { classNamed, classnamed };